export default "__VITE_ASSET__dSx2Nyg4__"